module.exports = __webpack_public_path__ + "img/icon_logo.64490f91.png";